import React, { useEffect, useState } from 'react';
import Tablas from '../../molecules/tablas/view'; // Import the existing Tablas molecule
import { getReceiptTypes } from '../../../usecases/receipts-usecase'; // Assuming getReceiptTypes is in receipts-usecase
import './style.css';
import ModalBtn from '../../molecules/modalButton/view';
import { BiReceipt } from 'react-icons/bi';
import EditReceiptType from '../EditReceiptType/view';
import CreateReceiptType from '../CreateReceiptType/view';
import { listener } from '../../../utils/dispatch';
import { EmptyArray } from '../../../domain/empty/model';

const ReceiptTypeTable = () => {
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [totalItems, setTotalItems] = useState(0); // Total items for pagination
  const itemsPerPage = 10

  const headersList = [
    'name',
    'description',
    'created_at',
  ];

  const excludeList = [
    "id",
    'credit_account_id',
    'debit_account_id',
  ]

  const mapper = (data) => {
    return data.map(item => (
      {
        id: item.id,
        name: item.name,
        description: item.description,
        credit_account_id: item.credit_account_id,
        debit_account_id: item.debit_account_id,
        created_at: item.created_at,
      }
    ))
  }

  const fetchReceiptTypes = async (pageToFetch = page, limitToFetch = limit) => {
    try {
      const result = await getReceiptTypes(pageToFetch, limitToFetch);
      const aux = mapper(result.data || []);
      if (aux.length === 0) {
        setReceiptTypes(EmptyArray);
      } else {
        setReceiptTypes(aux);
      }
      setTotalItems(result.total || 0);
      setPage(pageToFetch);
      setLimit(limitToFetch);
    } catch (error) {
      console.error("Error fetching receipt types:", error);
      setReceiptTypes(EmptyArray);
    }
  };

  useEffect(() => {
    const removeListener = listener("update-receipt-types", () => fetchReceiptTypes(page, limit));
    return () => {
      if (typeof removeListener === 'function') removeListener();
    };
  }, [page, limit]);

  const paginatedWrapper = {
    total: totalItems,
    page: page,
    page_size: limit,
    data: receiptTypes
  };

  const formats = {};

  return (
    <ModalBtn
      id="receipt-types-table"
      title="Recibos"
      icon={<BiReceipt />}
      onClick={() => fetchReceiptTypes(1, limit)}
      style={{ width: '65vw', maxWidth: '95vw' }}
    >
      <div className="receipt-type-table-organism">
        <Tablas
          id="receipt-type-table"
          paginatedData={paginatedWrapper}
          getFunction={fetchReceiptTypes}
          headersList={headersList}
          excludeList={excludeList}
          formats={formats}
          emptyMessage="No hay tipos de recibo para mostrar."
          allowPageSizeControl={true}
          toolbarActions={
            <CreateReceiptType />
          }
        >
          <EditReceiptType />
        </Tablas>
      </div>
    </ModalBtn>
  );
};

export default ReceiptTypeTable;
